module.exports = __webpack_public_path__ + "img/toplogo.4604ee97.png";